import InlineOrgPicker from './InlineOrgPicker';

export default InlineOrgPicker;
